
// src/connects/diary.js

import PropTypes from 'prop-types'
import ui from '../helpers/ui-state'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { trackHandlers } from '../helpers/analytics'
import actions from '../actions'
import { pushRoute } from '../actions/route'
import combineHOC from '../helpers/combine-hoc'
import context from '../helpers/context'
import { requireSocketEmit } from '../helpers/socket-rsync'
import some from 'lodash/some'
import each from 'lodash/each'
import uniq from 'lodash/uniq'
import find from 'lodash/find'
import { isSmartPhone } from '../helpers/agent-type'
import { emitAlertMessage } from '../actions/alert-message'

export const mapStateToProps = (state)=> {
  return {
    isPhone: state.media.isPhone,
    access_token: state.sessions.access_token,
    isRightSidePage:  false, // state.rightSidePage.name? true : false 一時対処
    _blockUsers: state.block.users,
    _blockDiaries: state.block.diaries,
    review: state.lambdaApi.stream,
    isFetching: state.lambdaApi.isFetching,
    isFetchFailed: state.lambdaApi.isFetchFailed,
    isOpenReviewPanel: state.lambdaApi.isOpenReviewPanel,
    isReviewCompleted: state.lambdaApi.isCompleted,
    isReviewEnable: state.reviewSetting.isEnable, 
    isShowTimeStamp: state.showTimeStamp.isEnable,
  }
}

var START_EM_TAG_REGEXP = /<em>/g
var END_EM_TAG_REGEXP = /<\/em>/g

export const mergeProps = (stateProps, dispatchProps, ownProps)=> {
  const blockUser = ownProps.diary && ownProps.diary.user && find(stateProps._blockUsers, (user)=> user.user_id == ownProps.diary.user.user_id)
  const blockDiary = ownProps.diary && find(stateProps._blockDiaries, (blockDiary)=> blockDiary.diary_id == ownProps.diary.diary_id)
  var highlights = []
  if (ownProps.diary.highlights){
    ownProps.diary.highlights.content && (highlights = highlights.concat(ownProps.diary.highlights.content))
    ownProps.diary.highlights.comments && (highlights = highlights.concat(ownProps.diary.highlights.comments))
  }
  var hits = []
  var match, matchEnd
  if (highlights.length > 0) {
    each(highlights, (item)=> {
      while((match = START_EM_TAG_REGEXP.exec(item))) {
        END_EM_TAG_REGEXP.lastIndex = match.index + 4
        matchEnd = END_EM_TAG_REGEXP.exec(item)
        hits.push(item.slice(match.index + 4, matchEnd && matchEnd.index || undefined).trim())
      }
    })
    hits = uniq(hits)
  }

  var isAttachment = false
  if (ownProps.diary.comments && ownProps.diary.comments.length > 3) {
    var _comments = ownProps.diary.comments.slice(0, ownProps.diary.comments.length - 3)
    isAttachment = some(_comments, (comment)=> comment.files.length > 0)
  }

  return {
    blockUser,
    blockDiary,
    searchHits: hits && hits.length > 0 && hits,
    isAttachment: isAttachment,
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
  }
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    deleteDiary: ()=> dispatch(
      actions.deleteDiary(ownProps.params ?  ownProps.params.diary.diary_id : ownProps.diary.diary_id)
    ),
    editDiary:   ()=> dispatch(actions.editDiary(ownProps.params ? ownProps.params.diary.diary_id : ownProps.diary.diary_id)),
    likeDiary:   ()=> dispatch(actions.likeDiary(ownProps.diary.diary_id)),
    pinDiary:    ()=> dispatch(actions.pinDiary(ownProps.params ? ownProps.params.diary.diary_id : ownProps.diary.diary_id)),
    unpinDiary:  ()=> dispatch(actions.unpinDiary(ownProps.params ? ownProps.params.diary.diary_id : ownProps.diary.diary_id, ownProps.group.group_id)),
    reactionDiary: (like_type)=> dispatch(actions.likeDiary(ownProps.diary.diary_id, like_type)),
    pickupDiary: ()=> dispatch(
      actions.openRightSidePage('pickup_diaries', isSmartPhone ? {
          group_id: !ownProps.diary.group && ownProps.group && ownProps.group.group_id || undefined,
          diary_ids: [ownProps.diary.diary_id],
          diaries: [ownProps.diary],
        } : {
          group_id: !ownProps.diary.group && ownProps.group && ownProps.group.group_id || undefined,
          append: { diary_ids: [ownProps.diary.diary_id] }
        },
        true
      )),
    readDiary:   ()=> {
      if (ownProps._readDiary)
        ownProps._readDiary(ownProps, ownProps.diary)
      else
        dispatch(actions.markDiaryRead(ownProps.diary.diary_id))
    },
    unlikeDiary: ()=> {
      var like = find(ownProps.diary.likes, (_like)=> _like.user.user_id == ownProps.user.user_id)
      like && dispatch(actions.deleteLike(like.like_id))
    },

    submitStamp: (code, props) => {
      if (!code)
        return
        dispatch(actions.postComment(
          props.parent.comment_id ? 'comment_id' : 'diary_id',
          props.parent.comment_id || props.parent.diary_id,
          `<div><span class="stamp ${code}"></span></div>`
        ))
    },

    navigateDiaryDetail: (parent, isComment, editComment)=> {
      dispatch(actions.openRightSidePage('diary_details', {
        diary: ownProps.diary,
        group: ownProps.group ? ownProps.group : ownProps.diary.group,
        initialParent: parent,
        isComment, editComment
      }))
    },

    translateDiary: (diary_id = undefined)=> {
      dispatch(actions.translateDiary(ownProps.group && ownProps.group.group_id || 'home', ownProps.diary && ownProps.diary.diary_id || diary_id))
    },

    showGroup: ()=> {
      dispatch(actions.closeRightSidePage())
      pushRoute('group_timeline', { group_id: ownProps.diary.group.group_id })
    },
    showUser:  ()=> {
      dispatch(actions.openRightSidePage(
        'user_timeline', {
          group_id: !ownProps.diary.group && ownProps.group && ownProps.group.group_id || undefined,
          user_id: ownProps.diary.user.user_id
        }
      ))
    },
    showReaders:     (props)=> dispatch(actions.openRightSidePage('likes_readers', { diary_id: ownProps.diary.diary_id, tab: props.types }, true)),
    showAttachments: ()=> dispatch(actions.openRightSidePage('attachments', { diary_id: ownProps.diary.diary_id }, true)),
    appAlertMessage: () => dispatch(emitAlertMessage({ message: 'label:ファイルを開けません' }, 'error')),
    updateBlockDiary: (diary, isBlock)=> {
      dispatch(actions.updateBlockDiary(diary.diary_id, isBlock))
      dispatch(emitAlertMessage({ message: isBlock ? 'label:投稿をブロックしました' : 'label:投稿をブロック解除しました', name: diary && diary.user.name }, 'success'))
    },
    postContentReport: (props) => {
      const user_id = ownProps.user && ownProps.user.user_id || props.user.user_id
      dispatch(actions.postContentReport(user_id, props.diary.diary_id))
    },
    askGpt: (message)=> dispatch(actions.fetchReview(message)),
    onOpenReview: ()=> dispatch(actions.openReviewPanel()),
    onCloseReview: ()=> dispatch(actions.closeReviewPanel()),
  }
}

export default combineHOC(
  ui({
    state: {
      openReaction: false,
    }
  }),
  context({ _readDiary: PropTypes.func, emitSocket: PropTypes.func, showImagesView: PropTypes.func, showStampPalette: PropTypes.func }),
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  translate(),
  trackHandlers('pinDiary', 'pin_diary_submit'),
  trackHandlers('unpinDiary', 'unpin_diary_submit'),
  trackHandlers('askGpt', 'ask_gpt_diary'),
  trackHandlers('likeDiary', 'like_diary'),
  trackHandlers('reactionDiary', 'reaction_diary'),
)



// WEBPACK FOOTER //
// ./src/connects/diary.js